import _ from 'lodash';
import React from 'react';
import {submit, isSubmitting, formValueSelector} from 'redux-form';

import {MODALS} from 'ducks/tenancy';

import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';
import {BookingOption} from 'components/Fields/BookingSelectField/components';

import './styles.css';

class ConfirmPaymentModal extends React.Component<any> {
  onSubmit = () => {
    this.props.closeModal();

    this.props.submit('receivePayment');
  };

  render() {
    const {
      data: {
        form: {submitting, paymentMethod, amount},
        invoiceDescription,
        booking
      }
    } = this.props;

    const sections = [
      {heading: 'Invoice Description', value: invoiceDescription || '-'},
      {heading: 'Payment method', value: _.get(paymentMethod, 'label', '-')},
      {heading: 'Total amount', value: `£${amount || ' -'}`},
      {heading: 'For booking', value: <BookingOption object={booking} />}
    ];

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.EXTRA_SMALL}
        className="ConfirmPaymentModal">
        <Modal.Header heading="Confirm payment" />
        <Modal.Body>
          <div className="ConfirmPaymentModal__message">
            You will create a payment for
          </div>
          {sections.map(section => (
            <div key={section.heading} className="ConfirmPaymentModal__section">
              <div className="ConfirmPaymentModal__section__label colab-bold">
                {section.heading}
              </div>
              <div className="ConfirmPaymentModal__section__value">
                {section.value}
              </div>
            </div>
          ))}
          <div className="ConfirmPaymentModal__question">
            Are you sure you want to add this payment?
          </div>
        </Modal.Body>
        <Modal.Footer className="colab-row-space-between">
          <Button white onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button
            onClick={this.onSubmit}
            blue={!submitting}
            isLoading={submitting}
            disabled={submitting}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('receivePayment');

const mapStateToModalData = state => ({
  form: {
    submitting: isSubmitting('receivePayment')(state),
    description: formSelector(state, 'description'),
    paymentMethod: formSelector(state, 'paidTo'),
    amount: formSelector(state, 'amount')
  }
});

const mapDispatchToProps = {
  submit
};

export default withModal(
  MODALS.CONFIRM_PAYMENT,
  mapStateToModalData,
  mapDispatchToProps
)(ConfirmPaymentModal);
